export const getNextDate = () => {
	let newDate = new Date()
	newDate.setDate(newDate.getDate() + 1)
	const date = newDate.getDate()
	const month = newDate.getMonth() + 1
	const year = newDate.getFullYear()
	return `${year}-${month < 10 ? `0${month}` : `${month}`}-${date < 10 ? `0${date}` : date}`
}

export const getSpecificDate = (daysToAdd: number) => {
	let newDate = new Date()
	newDate.setDate(newDate.getDate() + daysToAdd)
	const date = newDate.getDate()
	const month = newDate.getMonth() + 1
	const year = newDate.getFullYear()
	return `${year}-${month < 10 ? `0${month}` : `${month}`}-${date < 10 ? `0${date}` : date}`
}
